<template>
	<app-page>
		<app-heading :title="isNew ? 'New Manager' : manager.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'marketmanagers' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Name"
					v-model="manager.name"
					required
					:errors="errors.name"
				/>
				<input-text
					type="email"
					label="Email"
					v-model="manager.email"
					required
					:errors="errors.email"
				/>
				<input-text
					type="phone"
					label="Phone"
					v-model="manager.phone"
					required
					:errors="errors.phone"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			manager: {
				name: '',
				email: '',
				phone: '',
			},
			errors: {},
		}
	},
	computed: {
		id() {
			return this.$route.params.manager
		},
		isNew() {
			return this.id === 'new'
		},
	},
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.manager = await this.$ravello.request()
					.v(2)
					.to('marketmanagers')
					.to(this.id)
					.get()
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data ? err.data.message : err.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			const request = this.$ravello.request()
				.v(2)
				.to('marketmanagers')

			const payload = {
				name: this.manager.name,
				email: this.manager.email,
				phone: this.manager.phone,
			}
			try {
				if (this.isNew) {
					await request.create(payload)
				} else {
					await request.to(this.id).update(payload)
				}

				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Manager successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'marketmanagers' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
